import { render, staticRenderFns } from "./AccountCard.vue?vue&type=template&id=203f380e&scoped=true"
import script from "./AccountCard.vue?vue&type=script&lang=js"
export * from "./AccountCard.vue?vue&type=script&lang=js"
import style0 from "./AccountCard.vue?vue&type=style&index=0&id=203f380e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203f380e",
  null
  
)

export default component.exports